// @flow

import { useEffect, useState } from 'react';

import { Detection } from 'Constants';
import { Width } from 'styles';

const useBreakpoints = (
  breakpoints = {
    tablet: Width.BREAK_MD,
    desktop: Width.BREAK_XL,
  }
) => {
  const [breakpoint, setBreakpoint] = useState('');
  const keys = Object.keys(breakpoints).reverse();
  useEffect(() => {
    const listener = () => {
      let bp: string = '';
      keys.forEach(key => {
        if (window.matchMedia(`(min-width: ${breakpoints[key]}px)`).matches) {
          if (!bp) bp = key;
        }
      });
      setBreakpoint(bp);
    };
    if (Detection.IS_BROWSER) {
      listener();
      window.addEventListener('resize', listener);
    }
    return () => window.removeEventListener('resize', listener);
    //eslint-disable-next-line
  }, []);
  return breakpoint;
};

export default useBreakpoints;
